module.exports = __webpack_public_path__ + "img/hapoalim-small.3dd2c05a.svg";